<template>
  <div class="recipes-view">
    <h2 class="title">{{ $t("Recipes") }}</h2>
    <TutorialBox id="recipeList">
      <p>{{ $t("Add your favorite recipes here.") }}</p>
      <p>
        {{
          $t(
            "Keep it simple: you don't need exact amounts or instructions. Just a list of ingredients that should go on your shopping list."
          )
        }}
      </p>
    </TutorialBox>
    <RecipeList
      :recipes="recipes"
      :primaryActionLabel="$t('Edit')"
      @primaryActionSelected="editExistingRecipe"
    />
    <div>
      <button
        v-on:click="editNewRecipe"
        class="button is-hidden-print recipe-list--recipe--add-button"
      >
        {{ $t("Add new recipe") }}
      </button>
      <recipe-edit
        v-if="editedRecipe"
        :recipe="editedRecipe"
        v-on:close="editedRecipe = null"
      />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Recipe } from "@/models/Recipe.ts";
import RecipeEdit from "@/components/RecipeEdit";
import RecipeList from "@/components/RecipeList";
import TutorialBox from "@/components/TutorialBox";

export default Vue.extend({
  name: "recipes",
  data: function () {
    return {
      editedRecipe: null,
    };
  },
  computed: {
    recipes: function () {
      return this.$store.state.recipes;
    },
  },
  methods: {
    editExistingRecipe: function (recipe) {
      this.editedRecipe = recipe;
    },
    editNewRecipe: function () {
      this.editedRecipe = new Recipe({
        name: "",
        ingredients: [],
      });
    },
  },
  components: {
    RecipeList,
    RecipeEdit,
    TutorialBox,
  },
});
</script>
<style scoped></style>
<i18n>
{
  "en": {
    "recipeImage": "An image of the dish",
    "addPhoto": "Add photo"
  },
  "de": {
    "Add new recipe": "Rezept hinzufügen",
    "Add your favorite recipes here.": "Trage hier deine Lieblingsrezepte ein.",
    "Keep it simple: you don't need exact amounts or instructions. Just a list of ingredients that should go on your shopping list.": "Du brauchst keine Mengenangaben. Einfach nur die Dinge, die auf deinen Einkaufszettel gehören.",
    "recipeImage": "Ein Bild des Rezepts",
    "addPhoto": "Foto hinzufügen"
  }
}
</i18n>
